import { get, post } from '@/util/request.js';
import type { StoredEntity } from '@fibl/oxs-common';
import { EavRepo, type EAV } from '@fibl/zdb-common';

export function getEntityclassByExternalId(extId: string): Promise<EAV.Entityclass> {
	return EavRepo.getEntityclassByExternalId(extId);
}

export async function getAttributesetByExternalId(extId: string): Promise<EAV.Attributeset> {
	return EavRepo.getAttributesetByExternalId(extId);
}

export function getDomain() {
	return get('eav/domain/getbyurl', null);
}

export async function updateEntity(ent: StoredEntity, mode?: 'anr' | 'cr'): Promise<void> {
	let params = {
		patch: ent.getPatch(),
		id: ent.getId(),
		rev: ent.getRev(),
		mode,
	};
	if (!params.patch.length) return;
	const data: EAV.Entity<Record<string,unknown>> = await post('eav/entity/updatefrompatch', params);
	ent.fromStorage(data);
}

export async function createEntity(ent: StoredEntity): Promise<void> {
	let params = {
		entityclass: ent.getEntityclass(),
		attributeset: ent.getAttributeSet(),
		data: ent.toStorage(),
	};
	if (params.entityclass && params.entityclass.length !== 36) {
		params.entityclass = (await getEntityclassByExternalId(params.entityclass)).id;
	}
	if (params.attributeset && params.attributeset.length !== 36) {
		params.attributeset = (await getAttributesetByExternalId(params.attributeset)).id;
	}
	let res = await post('eav/entity/create', params);
	ent.fromStorage(res);
}

export async function deleteEntity(id: string): Promise<void> {
	await post('eav/entity/delete', { id });
}

export async function getEntity<T extends Record<string,any>>(params: EAV.EntityGetRequest): Promise<EAV.Entity<T,{}>> {
	return get('eav/entity/get', params);
}